import { render, staticRenderFns } from "./TaskLayout.vue?vue&type=template&id=76280dc6&scoped=true"
import script from "./TaskLayout.vue?vue&type=script&lang=js"
export * from "./TaskLayout.vue?vue&type=script&lang=js"
import style0 from "./TaskLayout.vue?vue&type=style&index=0&id=76280dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76280dc6",
  null
  
)

export default component.exports